module.exports = __webpack_public_path__ + "media/images/smart_phone/shares/202001/logo_mie-14153b874991a41f48d149bc16038a8e.png";